import { createContext } from 'react';

/** @deprecated Temporary dual-layout rollout context. Remove when legacy layout is retired. */
type LayoutPreferenceContextValue = {
  isMenuPinnedOpen: boolean;
  isTabletMenuOpen: boolean;
  setIsMenuPinnedOpen: (nextValue: boolean) => void;
  setIsTabletMenuOpen: (nextValue: boolean) => void;
  setTabletMenuItemId: (nextValue: string | null) => void;
  setUseNewLayout: (nextValue: boolean) => void;
  tabletMenuItemId: string | null;
  useNewLayout: boolean;
};

export const LayoutPreferenceContext =
  createContext<LayoutPreferenceContextValue | null>(null);
